export function findTask(tasks, task) {
    const list = Array.isArray(tasks) ? tasks : Object.values(tasks)
    const byTaskId = list.find((t) => t.taskId != null && t.taskId === task.taskId)
    if (byTaskId) return byTaskId
    // task.id is positional ("scheduleId.position") and shifts when tasks are
    // inserted/removed, so it must NOT be used as a fallback when the task has
    // a real taskId — that would falsely match a brand-new task to whatever
    // previously occupied its slot, cascading the mismatch through the list.
    if (task.taskId != null) return undefined
    return list.find((t) => t.id != null && t.id === task.id)
}
